import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '@services/message.service';
import { NotificationService } from '@services/notification.service';
import { TestService } from '@services/test.service';
import { WebErrorService } from '@services/webError.service';
import { Subscription } from 'rxjs';
import { ScoringTypeEnum } from 'src/app/shared/config/questions.config';
import { customValidationService } from 'src/app/shared/custom.validator';
import { CollectionService } from '@services/collection.service';
@Component({
  selector: 'app-tests-basic-details',
  templateUrl: './tests-basic-details.component.html',
  styleUrls: ['./tests-basic-details.component.scss'],
})
export class TestsBasicDetailsComponent implements OnInit {
  @Input() itemBasicDetails: any;
  @Input() isPublished: boolean;
  testDetailsForm: FormGroup;
  testBasicdetails: any;
  globalcollectionid: any;
  testuuId: any;
  @Input() tabData: any;
  messageFlag = false;
  success = false;
  error = false;
  messages = '';
  messagesp = '';
  testDetails: any;
  messagesArray: any[] = [];
  currentIdBackup: string;
  testDetailsSubscription: Subscription;
  ScoringTypeEnum = ScoringTypeEnum;
  itemsCount: any;

  isStyleGroupShow = false;
  scoringTypes: any;
  scoringTypeId: any;
  styleGroupData: any;
  selectedScoringType: any;
  globalcollectionuuid: any;
  selectedstyleGroup: any;
  testData$: Subscription | undefined;
  evaluationMode: number;

  constructor(
    private testService: TestService,
    private messageService: MessageService,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public CollectionService: CollectionService,
    public dialogRef: MatDialogRef<TestsBasicDetailsComponent>
  ) { }

  ngOnInit(): void {
    this.globalcollectionuuid = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));
    const userData = JSON.parse(sessionStorage.getItem('currentUser'));
    this.evaluationMode = userData.evaluationmode;
    this.testService.TestItemCount.subscribe(data => {
      this.itemsCount = data != 0 ? true : null;
    });
    this.testDetails = this.data?.testData.data;
    this.testuuId = this.data?.testUUID;
    this.isPublished = false;

    this.testService.getScoringTypes().subscribe((scoringTypes) => {
      if(this.evaluationMode === 1){
        this.scoringTypes = scoringTypes.items.filter(type => type.scoringTypeId === 1 || type.scoringTypeId === 2);
      } else {
        this.scoringTypes = scoringTypes.items;
      }
    });
    this.testDetailsForm = new FormGroup({
      testTitle: new FormControl('', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(120),
        customValidationService.cannotContainSpace,
        Validators.pattern(/^[ a-zA-Z.-]+([ ]?[a-z0-9 !#|^*()-_@$!%*?&]){0,}$/)
      ]),
      testDescription: new FormControl('', [Validators.minLength(1), Validators.maxLength(480)]),
      scoringTypeId: new FormControl(0, [Validators.required]),
      styleGroupId: new FormControl("")
    });
    this.messageService.getMessageNext().subscribe((data) => {
      this.messageFlag = true;
      this.success = true;
      this.error = false;
      this.messages = data?.text;
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });

    this.testService.styleGroupList.subscribe(d => {this.styleGroupData = d;});
    if (this.testDetails) {
      if (this.testDetails?.statusName == "Published") { this.isPublished = true; }
      this.testData$ = this.testService.getTestDetail.subscribe(data => {
        this.testDetailsForm.setValue({ testTitle: data?.testTitle, testDescription: data?.testDescription,
          scoringTypeId: data?.scoringTypeId,
          styleGroupId: data?.styleGroupId});

        this.selectedScoringType = data?.scoringTypeId;

        if (data?.styleGroupId != 0 && data?.styleGroupId != null) this.selectedstyleGroup = data?.styleGroupId
        if (data?.scoringTypeId === 3) this.changeScoringType(data?.scoringTypeId);
      })
    }
  }

  changeScoringType(event) {
    this.isStyleGroupShow = parseInt(event) == 3 ? true : false;
    const styleGroupId = this.testDetailsForm.get('styleGroupId');

    if (parseInt(event) != 0) {
      if (parseInt(event) === 3) {
        styleGroupId.setValidators([Validators.required]);
      } else {
        styleGroupId.setValue('');
        styleGroupId.setValidators(null);
        styleGroupId.markAsUntouched();
      }
      styleGroupId.updateValueAndValidity();
    }
  }

  ngOnChanges(): void {
    this.testService.updateTestStatus.subscribe(isTestDisabled => {
      if (isTestDisabled == true) {
        this.isPublished = isTestDisabled;
      } else {
        this.isPublished = false;
      }
    })
    if (this.tabData) {
      this.messageFlag = false;
    }
  }

  get f() {
    return this.testDetailsForm.controls;
  }

  editBasicTestDetails() {
    if(!this.isPublished){
      if (this.testDetailsForm.value.testDescription != null) {
        this.testDetailsForm.value.testDescription =
          this.testDetailsForm.value.testDescription.trim();
      } else {
        this.testDetailsForm.value.testDescription =
          this.testDetailsForm.value.testDescription;
      }
      const apiData = {
        testTitle: this.testDetailsForm.value.testTitle.trim(),
        testDescription: this.testDetailsForm.value.testDescription,
        scoringTypeId: this.testDetailsForm.value.scoringTypeId,
        StyleGroupID: this.testDetailsForm.value?.styleGroupId
      };
      this.testService.updateTest(apiData, this.testuuId).subscribe(
        (resdata) => {
          sessionStorage.setItem('testScoringTypeId', resdata.data.scoringTypeId);
          this.testService.updatedTestDetails(resdata);
          this.testService.testDetails.next(resdata.data);
          this.success = true;
          this.notificationService.success(resdata?.message);
          this.dialogRef.close();
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
          this.testDetailsForm.controls['testTitle'].reset()
        }
      );
    };
  }
  ngOnDestroy() {
    if (this.testDetailsSubscription) {
      this.testDetailsSubscription.unsubscribe();
    }
    this.testData$.unsubscribe();
    this.isPublished = null;
  }
}
